// extracted by mini-css-extract-plugin
module.exports = {"page":"E-IRA_page_3lWF8","content":"E-IRA_content_3vuHM"};